import Vue from 'vue'
import { ToastPlugin, ModalPlugin, VBTooltip } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueQrcodeReader from "vue-qrcode-reader";
import VueSignature from "vue-signature-pad";
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import VueZoomer from "vue-zoomer";
import imagePreview from 'image-preview-vue'
import 'image-preview-vue/lib/imagepreviewvue.css'

Vue.use(imagePreview)
Vue.use(VueSignature);
// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.directive('b-tooltip', VBTooltip)
Vue.use(VueZoomer);
// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueQrcodeReader);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

Vue.prototype.loading = function (type) {
  if (type) {
    document.getElementById('loading-bg').style.display="";
  } else {
    document.getElementById('loading-bg').style.display="none";
  }
}
var numeral = require("numeral");
Vue.filter("number", function (value) {
  return numeral(value).format("0,0").replace(/,/g,".");
});

Vue.prototype.$select2 = function (obj,id,value) {
  if (obj!=null){
    if (id){
      obj.forEach(i=>{i.id = i[id];})
    }
    if (value){
      obj.forEach(i=>{i.text = i[value];})
    }
  }
  return obj;
}

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
